var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#7A4186"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4594 24.122H12.4054V8.9598H17.4594V12.7503C17.4594 13.4453 18.028 14.0139 18.7229 14.0139H22.5135V16.5409H23.777V12.7503C23.777 12.5608 23.7138 12.4345 23.5875 12.3081L19.1652 7.88582C19.0388 7.75946 18.9125 7.69629 18.7229 7.69629H12.4054C11.7104 7.69629 11.1418 8.26487 11.1418 8.9598V24.122C11.1418 24.8169 11.7104 25.3855 12.4054 25.3855H17.4594V24.122ZM18.7229 9.21251L22.2608 12.7503H18.7229V9.21251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.304 21.5944H23.777V19.0674H22.5135V21.5944H19.9865V22.8579H22.5135V25.385H23.777V22.8579H26.304V21.5944Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2162,
    height: 20.2162,
    fill: "white",
    transform: "translate(7.35132 6.43262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAdd);
export default __webpack_public_path__ + "static/media/Upload-Add.de6a8994b1e99168e63a943b7c337cc6.svg";
export { ForwardRef as ReactComponent };